import { render, staticRenderFns } from "./report-repair.vue?vue&type=template&id=0ec9cd60&scoped=true&"
import script from "./report-repair.vue?vue&type=script&lang=js&"
export * from "./report-repair.vue?vue&type=script&lang=js&"
import style0 from "./report-repair.vue?vue&type=style&index=0&id=0ec9cd60&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ec9cd60",
  null
  
)

export default component.exports